<div class="callback-container">
  <sh-spinner *ngIf="isProcessing && !hasError" overlay label="Authenticating and verifying user..."></sh-spinner>
  <div *ngIf="hasError" class="error-message">
    <p>{{ errorMessage }}</p>
  </div>
</div>
